function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["alt", "backgroundColor", "borderColor", "radius", "borderStyle", "borderWidth", "boxShadow", "image", "preset", "size", "style", "uiTheme"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { pickBy, identity, isFinite } from 'lodash';
import ImageResizer from '../ImageResizer';
import withTheme from '../Theme/withTheme';
import { getColor, getPreset, getRadius, getShadow } from '../Theme/selectors';
function getSrcSetUrls(_ref) {
  var image = _ref.image,
    size = _ref.size,
    transformation = _ref.transformation;
  var standardUrl = ImageResizer.resizeUrl(image, {
    w: size,
    h: size,
    t: transformation
  });
  var midImageSize = size * 1.5;
  var midImageUrl = ImageResizer.resizeUrl(image, {
    w: midImageSize,
    h: midImageSize,
    t: transformation
  });
  var retinaImageSize = size * 2;
  var retinaImageUrl = ImageResizer.resizeUrl(image, {
    w: retinaImageSize,
    h: retinaImageSize,
    t: transformation
  });
  return "".concat(standardUrl, " 1x, ").concat(midImageUrl, " 1.5x, ").concat(retinaImageUrl, " 2x");
}
var Avatar = function Avatar(props) {
  var alt = props.alt,
    backgroundColor = props.backgroundColor,
    borderColor = props.borderColor,
    radius = props.radius,
    borderStyle = props.borderStyle,
    borderWidth = props.borderWidth,
    boxShadow = props.boxShadow,
    image = props.image,
    presetName = props.preset,
    size = props.size,
    customStyle = props.style,
    uiTheme = props.uiTheme,
    otherProps = _objectWithoutProperties(props, _excluded);
  var preset = getPreset(uiTheme, 'avatar', presetName);
  var actualBorderWidth = borderWidth || preset.borderWidth;
  var style = pickBy({
    backgroundColor: getColor(uiTheme, backgroundColor) || getColor(uiTheme, preset.backgroundColor),
    borderRadius: getRadius(uiTheme, radius) || getRadius(uiTheme, preset.radius),
    borderColor: getColor(uiTheme, borderColor) || getColor(uiTheme, preset.borderColor),
    borderStyle: borderStyle || preset.borderStyle,
    borderWidth: actualBorderWidth === 'none' ? '0px' : actualBorderWidth,
    boxShadow: getShadow(uiTheme, boxShadow) || getShadow(uiTheme, preset.boxShadow)
  }, identity);
  function getBorderAdjustedSize() {
    var totalBorderWidth = (borderWidth || preset.borderWidth || 0) * 2;
    var actualSize = size || preset.size || 'auto';
    if (isFinite(actualSize) && isFinite(totalBorderWidth)) {
      return actualSize - totalBorderWidth;
    }
    return actualSize;
  }
  return /*#__PURE__*/React.createElement("img", _extends({}, otherProps, {
    src: ImageResizer.resizeUrl(image, {
      w: size,
      h: size,
      t: 'square'
    }),
    srcSet: getSrcSetUrls({
      image: image,
      size: size,
      transformation: 'square'
    }),
    alt: alt,
    width: getBorderAdjustedSize(),
    height: getBorderAdjustedSize(),
    style: _objectSpread(_objectSpread({}, style), customStyle)
  }));
};
Avatar.defaultProps = {
  backgroundColor: null,
  borderColor: null,
  radius: null,
  borderStyle: null,
  borderWidth: null,
  boxShadow: null,
  preset: 'default',
  size: null,
  style: {},
  uiTheme: null
};
Avatar.displayName = 'Avatar';
export default withTheme(Avatar);